import sharedFilters from './shared';

export default {
  pageFilters: [
    {
      id: 'content',
      label: 'Content',
      filters: {
        title: null,
        date: sharedFilters.date
      }
    },
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null,
        panel: sharedFilters.sampleBalance,
        age: null,
        gender: null
      }
    },
    {
      id: 'metric',
      label: 'Metric',
      filters: {
        metric: null
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilters.segments
      }
    }
  ],
  queries: {
    attributionTitle: {
      fields: [
        'panel',
        'date',
        'gender',
        'age',
        'country',
        'contentId',
        'contentName',
        'contentType',
        'platformName',
        'sampleSize',
        'voteCount',
        'titleVoteShare',
        'platformVoteShare',
        'title'
      ]
    }
  }
};
